<template>
	<div class="product-table">
		<p class="product-table__empty" v-if="!productList">{{ emptyText }}</p>
		<table class="table-main product-table__table" v-else>
			<tbody
				:class="{
					'product-table__table-item--selected': item.selected,
				}"
				v-for="item in productList"
				:key="item.idProduct"
			>
				<tr>
					<td class="product-table__img-cell" rowspan="3">
						<img
							class="product-table__img-cell__img"
							:src="item.productImg"
						/>
					</td>
					<td class="product-table__title-cell">카테고리</td>
					<td>
						{{ item.category }}
					</td>
					<td class="product-table__title-cell">용량/가격</td>
					<td>
						{{ item.volume }}
					</td>
					<td class="product-table__select-button-cell" rowspan="3">
						<button
							:class="[
								`btn ${item.selected ? 'gray' : 'blue'} product-table__select-button`,
							]"
							v-if="useSelectButton"
							@click="$emit('selecting', item)"
						>
							선택
						</button>
					</td>
				</tr>
				<tr>
					<td class="product-table__title-cell">브랜드</td>
					<td>
						{{ item.brandTitle }}
					</td>
					<td class="product-table__title-cell">평점/리뷰</td>
					<td>
						{{ item.ratingAvg }} / {{ item.reviewCount | currency }}
					</td>
				</tr>
				<tr>
					<td class="product-table__title-cell">제품명</td>
					<td colspan="3">
						<button
							class="link"
							@click="
								openWindow(
									`/product/product-inquiry/${item.idProduct}`
								)
							"
						>
							({{ item.idProduct }}) {{ item.productTitle }}
						</button>

						<span
							v-if="_.get(item, 'doc.isNew')"
							style="color: red; margin-left: 2em"
							>N</span
						>
						<span v-if="_.get(item, 'doc.weeklyWinnerCount')"
							>{{ _.get(item, 'doc.weeklyWinnerCount') }}주 연속
							1위</span
						>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		name: 'ProductTable',
		props: {
			productList: {
				type: Array,
				default: null,
			},
			emptyText: {
				type: String,
				default: '등록할 제품을 검색해 주세요.',
			},
			useSelectButton: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				productDetailPage: null,
			};
		},
		methods: {
			openWindow(url) {
				this.productDetailPage = window.open(url);
				this.productDetailPage.onload = () => {
					this.productDetailPage.modify = () => {
						this.$emit('product-updated');
						this.productDetailPage.close();
					};
				};
			},
		},
	};
</script>
<style lang="scss">
	DIV.product-table {
		.product-table__empty {
			width: 100%;
			height: 100%;
			text-align: center;
			background: white;
			line-height: 248px;
		}

		.product-table__table {
			table-layout: fixed;

			tbody:first-child td {
				border-top: none;
			}

			tr:hover {
				background-color: transparent;
			}

			td {
				text-align: left;
			}

			.product-table__img-cell,
			.product-table__select-button-cell {
				width: 105px;
			}

			.product-table__img-cell__img {
				display: block;
				width: 89px;
				height: 89px;
			}

			.product-table__title-cell {
				background-color: #f4f7fa;
			}

			.product-table__select-button {
				display: block;
				width: 60px;
				height: 60px;
				margin: 0 auto;
				padding: 0;
			}
		}

		.product-table__table-item--selected {
			background-color: lightgoldenrodyellow;
		}
	}
</style>
